import type { RecordOf } from 'immutable';
import { Record as ImmutableRecord } from 'immutable';

import { resourceStoreTypes } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import type { CreditReportAggregates, CreditScoreHistoryType } from './creditReportSchema';

export type {
  AgeOfCreditHistory,
  CreditInquiries,
  CreditReportAggregates,
  CreditScoreHistoryType,
  CreditUsage,
  DerogatoryRemarks,
  PaymentHistory,
  TotalAccounts,
} from './creditReportSchema';

export type CreditReportStore = QcsSyncResourceStore<CreditReportType>;
export const mkCreditReportStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<CreditReportType>();

export type CreditReportRefreshStatus = {
  status?: string;
};

export type CreditReportType = {
  id?: string;
  aggregates: CreditReportAggregates;
  providerCreditReportId?: string;
  creditScore: number | string;
  refreshDate: string;
  nextRefreshDate: string;
  refreshStatus?: CreditReportRefreshStatus;
  isRefreshed: boolean;
  datasetPlatformUsedInRegistration: string;
  creditScoreHistory: CreditScoreHistoryType[] | [];
};

export type CreditReport = RecordOf<CreditReportType>;

export const mkCreditReport = ImmutableRecord<CreditReportType>({
  id: undefined,
  aggregates: {},
  providerCreditReportId: undefined,
  creditScore: 0,
  refreshDate: '',
  nextRefreshDate: '',
  refreshStatus: undefined,
  isRefreshed: false,
  datasetPlatformUsedInRegistration: '',
  creditScoreHistory: [],
});

export const CREDIT_REPORT_REDUCER_KEY = 'creditReportStore';

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CREDIT_REPORT_REDUCER_KEY]: QcsSyncResourceStore<CreditReportType>;
  }
}
